import { withTracker } from '@/tracker';
import SEO from '@/components/seo';
import Hero from '@/components/business/rewards/hero';
import Features from '@/components/business/rewards/features';
import HowItWorks from '@/components/business/rewards/how-it-works';

function Incentives() {
  return (
    <>
      <SEO
        title="Rewards & Incentives"
        description="Better customer and employee incentive programs." />
      <Hero />
      <Features />
      <HowItWorks />
    </>
  );
}

export default withTracker(Incentives);
